/* globals $, setInterval, clearInterval, window */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { WithDeveloperShowFlash } from '../lib/DeveloperShowFlash';

import Header from './DifferentLayout/Header';
import LeftHandNav from './DifferentLayout/LeftHandNav';
import MainBody from './DifferentLayout/MainBody';
import Dialog from './Dialog';
import ModalView from './Modals/ModalView';
import DocumentViewer from './DocumentViewer';
import LayoutContainer from './DifferentLayout/LayoutContainer';
import MainBodyContainer from './DifferentLayout/MainBodyContainer';

import './Layout.scss';

// haxx
let navHeight;
let height;

type Props = {
  section: string
  staticView: string
}

@WithDeveloperShowFlash
export default class Layout extends Component<Props> {
  static propTypes = {
    section: PropTypes.string.isRequired,
    staticView: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    staticView: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      navHeight,
      height: null,
    };
  }

  componentDidMount() {
    const intervalCode = () => {
      // Measure the app header by its DOM marker rather than a ref to the
      // <Header> component: Header is wrapped in react-redux connect, which (v9)
      // does not forward refs, so under React 19 `this.header` is null and
      // getDOMNode(null) returned null -> navHeight undefined -> height NaN ->
      // the content area collapsed to 0 (blank page). This mirrors how
      // fixedHeightContent measures the header.
      navHeight = navHeight || $('[data-app-header]').outerHeight();
      height = $(window).height() - navHeight;
      const { navHeight: stateNavHeight, height: stateHeight } = this.state;

      if (navHeight !== stateNavHeight || height !== stateHeight) {
        this.setState({ navHeight, height });
      }
    };

    intervalCode();

    this.interval = setInterval(intervalCode, 250);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { section, staticView } = this.props;

    return (
      <LayoutContainer section={this.props.section}>
        <Header />
        <MainBodyContainer {...this.state} staticView={staticView}>
          <LeftHandNav staticView={staticView} />
          <MainBody section={section} staticView={staticView}>
            {this.props.children}
          </MainBody>
        </MainBodyContainer>
        <Dialog staticView={staticView} />
        <ModalView staticView={staticView} />
        <DocumentViewer staticView={staticView} />
      </LayoutContainer>
    );
  }
}
